function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M0 4.114c0 .73.188 1.415.513 2.01l.004.012a.34.34 0 00.021.046l.004.004L3.7 11.812c.066.117.19.189.322.188a.367.367 0 00.319-.193l3.121-5.642.004-.004a.374.374 0 00.029-.067c.316-.588.505-1.26.505-1.98C8 1.874 6.244.048 4.07.008c-.005 0-.008-.004-.013-.004A.363.363 0 004.02 0H4C1.793 0 0 1.85 0 4.114zM4 1.62c1.27 0 2.308 1.07 2.308 2.377C6.308 5.305 5.27 6.371 4 6.371c-1.27 0-2.308-1.066-2.308-2.374C1.692 2.69 2.73 1.62 4 1.62z",
  fill: "#F58220",
  fillRule: "evenodd"
});

function SvgLocationOrange(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 8 12"
  }, props), _ref);
}

export default SvgLocationOrange;